import React, { useEffect, useState } from 'react';
import { actionAddressConfig } from '../../../store/common/actions';
import Loading from '../../Common/Loading';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import DropdownIndicator from '../../Common/DropdownIndicator';
import { styles, alphabetAndNumberOnly, sw2Alert, options } from '../../../utils/common';
import Select from 'react-select';
import { actionCompleteWithoutEkyc, actionMonitorTracking } from '../../../store/application/actions';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

function AddressForm({ onChange, form1, lendelaData }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        setValue,
        register,
        handleSubmit,
        setError,
        formState: { errors, isSubmitting },
    } = useForm();
    const [estate, setEstate] = useState('');
    const [addressConfig, setAddressConfig] = useState(null);
    const [optionsDistrict, setOptionsDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState(null);
    const [isLoading, setLoading] = useState(false);

    const getAddressConfig = async () => {
        setLoading(true)
        const response = await dispatch(actionAddressConfig());
        console.log(response);
        if (response?.sts_code === 0) {
            setAddressConfig(response.content);
        } else {
            setAddressConfig({
                area: options.area,
                district_hk: options.district_hk,
                district_kw: options.district_kw,
                district_nt: options.district_nt,
            })
        }
        setLoading(false);
    }

    useEffect(() => {
        getAddressConfig();
        console.log('lendelaData', lendelaData);
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        }
    }, []);

    const onSubmit = async (data) => {
        console.log(data);
        const application_date = moment().format('YYYY-MM-DDTHH:mm:ss') + "Z";
        const district = optionsDistrict.find(t => t.value === districtValue?.value);
        const province = addressConfig.area.find(t => t.value === data?.area);

        let addr_line1 = '';
        if (data?.addr_line1_room) {
            addr_line1 = 'RM ' + (data?.addr_line1_room ?? '')
                .replace(new RegExp('ROOM', 'g'), '')
                .replace(new RegExp('RM', 'g'), '')
                .replace(new RegExp('FLAT', 'g'), '')
                .replace(new RegExp('FLT', 'g'), '')
                .replace(new RegExp('UNIT', 'g'), '').trim();
        }
        if (data?.addr_line1_floor) {
            addr_line1 += ' ' + (data?.addr_line1_floor ?? '')
                .replace(new RegExp('FLOOR', 'g'), '')
                .replace(new RegExp('F', 'g'), '')
                .replace(new RegExp("/F", 'g'), '').trim()
                + '/F';
        }
        if (data?.addr_line1_block) {
            addr_line1 += ' BLK ' + data?.addr_line1_block
                .replace(new RegExp('BLK', 'g'), '')
                .replace(new RegExp('BLOCK', 'g'), '')
                .replace(new RegExp("BL", 'g'), '').trim();
        }
        if (addr_line1.length > 49 || data?.estate?.length > 49) {
            return sw2Alert('輸入的地址不可以超過50個字元');
        };

        const utm_medium = sessionStorage.getItem('utm_medium');
        const utm_source = sessionStorage.getItem('utm_source');
        const utm_campaign = sessionStorage.getItem('utm_campaign');
        const utm_id = sessionStorage.getItem('utm_id');
        const utm_term = sessionStorage.getItem('utm_term');
        const utm_content = sessionStorage.getItem('utm_content');
        const session_id = localStorage.getItem('session_id');
        const access_query = `utm_medium=${utm_medium ?? ''}&utm_source=${utm_source ?? ''}&utm_campaign=${utm_campaign ?? ''}&utm_id=${utm_id ?? ''}&utm_term=${utm_term ?? ''}&utm_content=${utm_content ?? ''}`;

        const { application_ip,
            application_browser,
            application_device,
            cust_gender,
            date_of_birth,
            education,
            email,
            first_name,
            last_name,
            hkid,
            loan_amount,
            loan_purpose,
            marriage_status,
            phone_number,
            agree_doc
        } = form1;
        const dataForm = {
            "application_date": application_date,
            "application_ip": application_ip,
            "application_browser": application_browser,
            "application_device": application_device,
            "first_vist_date": application_date,
            "apply_access_data": {
                "access_data_id": "",
                "access_referer": "No Referer",
                "access_query": access_query ?? '',
                "utm_source": utm_source ?? '',
                "utm_medium": utm_medium ?? '',
                "session_id": session_id ?? ''
            },
            "lendela_id": null,
            "application_form_data": {
                "addr_line1": addr_line1,
                "addr_line2": data?.estate,
                "province_id": province?.province_id,
                "city_id": district?.city_id,
                "cust_gender": cust_gender,
                "date_of_birth": parseInt(date_of_birth),
                "education": education,
                "email": email,
                "first_name": first_name,
                "hkid": hkid,
                "last_name": last_name,
                "loan_amount": parseInt(loan_amount),
                "loan_purpose": loan_purpose,
                "marriage_status": marriage_status,
                "phone_number": phone_number,
                "agree_doc": JSON.parse(agree_doc)
            }
        }

        if (lendelaData) {
            dataForm['lendela_id'] = lendelaData['id'];
        }
        
        const response = await dispatch(actionCompleteWithoutEkyc(dataForm))
        await dispatch(actionMonitorTracking({
            status: 'QUICK_APP',
            type: 1
        }));
        console.log(response)
        if (response?.sts_code === 0) {
            navigate('/application/confirm/complete', { replace: true, state: { status: true, completed: false, content: '', no_form23: true } });
        }
    }

    return (
        <>
            <Loading isVisible={isLoading || isSubmitting} />
            <div className="p-8 fixed w-full z-[60] top-0 left-0 flex items-center justify-center h-full" style={{ backgroundColor: '#0000004d' }}>
                <div className="p-6 bg-white w-full rounded-md shadow-md text-gray overflow-hidden overflow-y-scroll max-h-[80vh]" style={{ maxWidth: 414 }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="p-5">
                            <p className="text-bold text-justify">輸入住址後請向下滑並點擊「提交申請」。</p>
                            <div className="my-4">
                                <div className="mb-2">
                                    <p className="text-gray">區域</p>
                                    <div className="border-b border-primary relative">
                                        <Select
                                            placeholder="- 請選擇 -"
                                            className="w-full"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                            })}
                                            styles={styles}
                                            {...register('area', { required: true })}
                                            onChange={(e) => {
                                                setValue('area', e.value);
                                                setError('area', null);
                                                setDistrictValue(null);
                                                setValue('district', null)
                                                switch (e.value) {
                                                    case 'HK':
                                                        setOptionsDistrict(addressConfig.district_hk);
                                                        break;
                                                    case 'KLN':
                                                        setOptionsDistrict(addressConfig.district_kw);
                                                        break;
                                                    case 'NT':
                                                        setOptionsDistrict(addressConfig.district_nt);
                                                        break;
                                                    default:
                                                        break;
                                                }
                                            }}
                                            options={addressConfig?.area}
                                            isSearchable={false}
                                            components={{ DropdownIndicator }}
                                        />
                                    </div>
                                    {errors.area && errors.area.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                                </div>
                                <div className="mb-2">
                                    <p className="text-gray font-bold">地區</p>
                                    <div className="border-b border-primary relative">
                                        <Select
                                            placeholder="- 請選擇 -"
                                            className="w-full"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                            })}
                                            styles={styles}
                                            {...register('district', { required: true })}
                                            value={districtValue}
                                            onChange={(e) => {
                                                setDistrictValue(e)
                                                setValue('district', e?.value)
                                                setError('district', null)
                                            }}
                                            options={optionsDistrict}
                                            isSearchable={false}
                                            components={{ DropdownIndicator }}
                                        />
                                    </div>
                                    {errors.district && errors.district.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                                </div>
                                <div className="mb-2">
                                    <p className="text-gray font-bold mb-1">單位</p>
                                    <div className="flex items-center border-b border-primary">
                                        <input
                                            {...register('addr_line1_room', { required: true })}
                                            onChange={(e) => {
                                                const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                                setValue('addr_line1_room', value)
                                            }}
                                            className="flex-1 px-1 outline-none text-primary w-full"
                                            placeholder="Room/Flat/Unit"
                                        />
                                    </div>
                                    {errors.addr_line1_room && errors.addr_line1_room.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                                </div>
                                <div className="mb-2">
                                    <p className="text-gray font-bold mb-1">樓層</p>
                                    <div className="flex items-center border-b border-primary">
                                        <input
                                            {...register('addr_line1_floor', { required: false })}
                                            onChange={(e) => {
                                                const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                                setValue('addr_line1_floor', value)
                                            }}
                                            className="flex-1 px-1 outline-none text-primary w-full"
                                            placeholder="Floor"
                                        />
                                    </div>
                                    {errors.addr_line1_floor && errors.addr_line1_floor.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                                </div>
                                <div className="mb-2">
                                    <p className="text-gray font-bold mb-1">座數/大廈</p>
                                    <div className="flex items-center border-b border-primary">
                                        <input
                                            {...register('addr_line1_block', { required: false })}
                                            onChange={(e) => {
                                                const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                                setValue('addr_line1_block', value)
                                            }}
                                            className="flex-1 px-1 outline-none text-primary w-full"
                                            placeholder="Block"
                                        />
                                    </div>
                                    {errors.addr_line1_block && errors.addr_line1_block.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                                </div>
                                <div className="mb-2">
                                    <p className="text-gray font-bold mb-1">屋苑/街道</p>
                                    <div className="flex items-center border-b border-primary">
                                        <input
                                            {...register('estate', { required: true })}
                                            value={estate}
                                            onChange={(e) => {
                                                const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                                setEstate(value)
                                            }}
                                            className="flex-1 px-2 outline-none text-primary w-full"
                                            placeholder="(E.g. HAPPY EST)"
                                        />
                                    </div>
                                    {errors.estate && errors.estate.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-center mb-2">
                            <button disabled={isSubmitting} type="submit" className={`rounded-full text-white text-xl px-14 py-3 ${isSubmitting ? 'bg-mercury' : 'bg-primary'}`}>
                                提交申請
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
        
    );
}

export default AddressForm;
